module.exports = __webpack_public_path__ + "img/detail-pc.1b7b07b7.png";